import { env } from '../env';

const CAPTCHA_KEY: string = env.captchaKey;

const CaptchaScript = () => {
  return <script defer src={`https://www.google.com/recaptcha/enterprise.js?render=${CAPTCHA_KEY}`} />;
};

const tokenExtractionTimeout = 4000;
const scriptLoadPollInterval = 200;

// script is deferred and can be blocked, so `grecaptcha` might be missing at the moment of submit
const getRecaptchaEnterprise = () => window.grecaptcha?.enterprise;

const extractToken = (): Promise<string> =>
  new Promise((resolve, reject) => {
    const startedAt = Date.now();

    const executeWhenLoaded = () => {
      const recaptchaEnterprise = getRecaptchaEnterprise();

      if (!recaptchaEnterprise) {
        if (Date.now() - startedAt < tokenExtractionTimeout) {
          setTimeout(executeWhenLoaded, scriptLoadPollInterval);
        }

        return;
      }

      recaptchaEnterprise.ready(() => {
        (getRecaptchaEnterprise() ?? recaptchaEnterprise)
          .execute(CAPTCHA_KEY, { action: 'login' })
          .then(resolve, reject);
      });
    };

    executeWhenLoaded();
  });

const createTimeoutPromise = (): Promise<never> =>
  new Promise((resolve, reject): void => {
    setTimeout(() => {
      reject(
        new Error(
          getRecaptchaEnterprise() ? 'Getting reCaptcha token has timed out' : 'reCaptcha script has not been loaded',
        ),
      );
    }, tokenExtractionTimeout);
  });

const getCaptchaToken = (): Promise<string> =>
  Promise.race([extractToken(), createTimeoutPromise()]).then(
    (value) => value,
    (err: unknown) => {
      console.error(err);

      throw err;
    },
  );

export { CAPTCHA_KEY, CaptchaScript, getCaptchaToken };
